/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebApp_viewer = {
    readonly user: {
        readonly flowStates: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly flowKey: string | null;
                    readonly previousState: string | null;
                    readonly current: {
                        readonly id: string;
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly pending: {
                        readonly id: string;
                        readonly state: string | null;
                        readonly percentComplete: number | null;
                        readonly errorMessage: string | null;
                    } | null;
                    readonly " $fragmentRefs": FragmentRefs<"FlowStatePoller_flowState">;
                } | null;
            } | null> | null;
        } | null;
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly domains: ReadonlyArray<string | null> | null;
                    readonly primaryOrgCalendar: string;
                    readonly shadowCalendarSettingsErrorable: {
                        readonly shadowCalendarId?: string | null | undefined;
                    };
                    readonly orgMeetingHours: {
                        readonly workingHours: {
                            readonly timeZone: string | null;
                        } | null;
                    } | null;
                    readonly flowStates: {
                        readonly edges: ReadonlyArray<{
                            readonly node: {
                                readonly id: string;
                                readonly flowKey: string | null;
                                readonly previousState: string | null;
                                readonly current: {
                                    readonly id: string;
                                    readonly state: string | null;
                                    readonly percentComplete: number | null;
                                    readonly errorMessage: string | null;
                                } | null;
                                readonly pending: {
                                    readonly id: string;
                                    readonly state: string | null;
                                    readonly percentComplete: number | null;
                                    readonly errorMessage: string | null;
                                } | null;
                                readonly " $fragmentRefs": FragmentRefs<"FlowStatePoller_flowState">;
                            } | null;
                        } | null> | null;
                    } | null;
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"WebAppChromeCard_viewer">;
    readonly " $refType": "WebApp_viewer";
};
export type WebApp_viewer$data = WebApp_viewer;
export type WebApp_viewer$key = {
    readonly " $data"?: WebApp_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WebApp_viewer">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v3 = {
        "alias": null,
        "args": (v0 /*: any*/),
        "concreteType": "FlowStateConnection",
        "kind": "LinkedField",
        "name": "flowStates",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FlowState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "flowKey",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "previousState",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "current",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "FlowStatus",
                                "kind": "LinkedField",
                                "name": "pending",
                                "plural": false,
                                "selections": (v2 /*: any*/),
                                "storageKey": null
                            },
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "FlowStatePoller_flowState"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "storageKey": "flowStates(first:1000000)"
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "WebApp_viewer",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    (v3 /*: any*/),
                    {
                        "alias": null,
                        "args": (v0 /*: any*/),
                        "concreteType": "OrgConnection",
                        "kind": "LinkedField",
                        "name": "orgs",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Org",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            (v1 /*: any*/),
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "domains",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "primaryOrgCalendar",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": null,
                                                "kind": "LinkedField",
                                                "name": "shadowCalendarSettingsErrorable",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "shadowCalendarId",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "type": "ShadowCalendarSettings",
                                                        "abstractKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "OrgMeetingHours",
                                                "kind": "LinkedField",
                                                "name": "orgMeetingHours",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "WorkingHours",
                                                        "kind": "LinkedField",
                                                        "name": "workingHours",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "alias": null,
                                                                "args": null,
                                                                "kind": "ScalarField",
                                                                "name": "timeZone",
                                                                "storageKey": null
                                                            }
                                                        ],
                                                        "storageKey": null
                                                    }
                                                ],
                                                "storageKey": null
                                            },
                                            (v3 /*: any*/)
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": "orgs(first:1000000)"
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WebAppChromeCard_viewer"
            }
        ],
        "type": "Viewer",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '62ed96b2787ca2aa77fbd8c3dcffa931';
export default node;
